import { currentFiltersProps, Enums } from './interface'

interface filtersType {
  type:
    | 'input-string'
    | 'input-integer'
    | 'select'
    | 'phone'
    | 'dates'
    | 'filter_group'
    | 'select_multiple'
  items?: filtersType[]
  name: string
  label?: string
  options?: {
    enum?: Array<{ label: string; value: string | number }>
    width?: string
    tooltip?: string
    allowClear?: boolean
    mode?: 'multiple' | 'tags'
  }
  style?: React.CSSProperties
  placeholder?: string | string[]
  prefix?: string
  disabled?: boolean
  value?: string | number | readonly string[] | string[]
  skipReset?: boolean
}

export const getFilters = ({
  currentFilters,
  availableFilters,
  isLeader,
}: {
  currentFilters: currentFiltersProps
  availableFilters: Enums
  isLeader: boolean
}): filtersType[] => {
  const filters: filtersType[] = [
    {
      name: 'id',
      label: 'Найти монтаж',
      placeholder: 'Найти монтаж',
      prefix: 'ID',
      type: 'input-integer',
      value: currentFilters?.id,
      options: {
        width: '170px',
      },
    },
    {
      name: 'stage',
      label: 'Фильтр по стадии',
      placeholder: 'Выберите стадию',
      type: 'select_multiple',
      value: currentFilters?.stage,
      options: {
        enum: availableFilters?.stage,
      },
    },
    {
      name: 'production_number',
      label: 'Номер производственного заказа',
      placeholder: 'Номер производственного заказа',
      type: 'input-string',
      value: currentFilters?.production_number,
    },
    {
      name: 'montage_date',
      label: 'Дата планового монтажа',
      type: 'dates',
      options: {
        tooltip: 'Дата планового монтажа',
      },
      value: currentFilters?.montage_date,
    },
    {
      name: 'montage_datetime',
      label: 'Дата фактического монтажа',
      type: 'dates',
      options: {
        tooltip: 'Дата фактического монтажа',
      },
      value: currentFilters?.montage_datetime,
    },
    {
      name: 'delivery_date',
      label: 'Дата плановой доставки',
      type: 'dates',
      options: {
        tooltip: 'Дата плановой доставки',
      },
      value: currentFilters?.delivery_date,
    },
    {
      name: 'manager',
      label: 'Менеджер',
      placeholder: 'Выберите менеджера',
      type: 'select',
      value: currentFilters?.manager,
      options: {
        enum: availableFilters?.manager,
      },
    },
    {
      name: 'responsible',
      label: 'Ответственный за монтаж',
      placeholder: 'Выберите ответственного',
      type: 'select',
      value: currentFilters?.responsible,
      options: {
        enum: availableFilters?.responsible,
      },
    },
  ]

  if (isLeader) {
    filters.push(
      {
        name: 'office',
        label: 'Офис',
        placeholder: 'Выберите офис',
        type: 'select',
        value: currentFilters?.office,
        options: {
          enum: availableFilters?.office || [],
        },
      },
      {
        name: 'brand',
        label: 'Бренд',
        placeholder: 'Выберите бренд',
        type: 'select',
        value: currentFilters?.brand,
        options: {
          enum: availableFilters?.brand || [],
        },
      },
    )
  }

  return filters
}
